import { GETTERS, STATE } from "./names";
import type { State } from "./types";

export default {
    [GETTERS.NOTIFICATIONS_BAR_OPEN]: (state: State) => state[STATE.NOTIFICATIONS_BAR_OPEN],
};